import script from "./companysettings.vue?vue&type=script&setup=true&lang=js"
export * from "./companysettings.vue?vue&type=script&setup=true&lang=js"

import "./companysettings.vue?vue&type=style&index=0&id=66d6fda1&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66d6fda1"]])

export default __exports__